import React from "react";
import DatePicker from "react-datepicker";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import styled from "styled-components";
import FlexBox from "../../common/FlexBox";
import { Body2 } from "../../common/Headings";
import {
  DAVYS_GREY_400,
  DAVYS_GREY_600,
  MOSS_GREEN_800,
  PRIMARY_800,
} from "../../common/colors";
import dayjs from "dayjs";

const CalendarHeader = styled(FlexBox)`
  border-bottom: 1px solid ${DAVYS_GREY_400};
  padding: 1rem;
  width: 20rem;
  justify-content: space-between;
  align-items: center;
`;

const MonthName = styled(FlexBox)``;

const Wrapper = styled(FlexBox)`
  width: 100%;
  height: 100%;
  align-items: center;
  .react-datepicker {
    font-family: "Quicksand";
    border-radius: 8px;
    border: 1px solid ${DAVYS_GREY_400};
  }
  .react-datepicker-wrapper .react-datepicker__input-container input {
    cursor: pointer;
    padding: 0.75rem;
    height: 3rem;
    width: 100%;
  }
  .react-datepicker__header {
    background: white;
    border-bottom: none;
    margin: 0;
    padding: 0;
    border-radius: 8px;
  }

  .react-datepicker-popper[data-placement^="bottom"]
    .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^="bottom"]
    .react-datepicker__triangle::after {
    display: none;
  }

  .react-datepicker__day-name {
    color: ${DAVYS_GREY_600};
    font-weight: 700;
    width: 2.4rem;
  }

  .react-datepicker__day,
  .react-datepicker__time-name {
    font-weight: 700;
    width: 2.4rem;
    color: ${MOSS_GREEN_800};
  }

  .react-datepicker__day--highlighted,
  .react-datepicker__month-text--highlighted,
  .react-datepicker__quarter-text--highlighted,
  .react-datepicker__year-text--highlighted {
    color: ${PRIMARY_800} !important;
    background: transparent;
    font-weight: 700;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    color: ${PRIMARY_800} !important;
    background: transparent;
    font-weight: 700;
  }
`;

const IconWrapper = styled(FlexBox)`
  justify-content: center;
  align-items: center;
  border: 1px solid ${DAVYS_GREY_400};
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  cursor: pointer;
`;

const Datepicker = ({
  handleChange,
  selectedDate,
  placeholderText,
  dateFormat,
  minDate,
  allowToday = false,
  maxDate,
}) => {
  const fewLeft = [];
  const unavailable = [];
  let in3Months = dayjs(new Date()).add(3, "months").toDate();
  return (
    <Wrapper>
      <DatePicker
        minDate={
          allowToday
            ? new Date()
            : dayjs(minDate).add(1, "day").toDate() || new Date()
        }
        maxDate={maxDate === undefined ? in3Months : maxDate}
        maxTime={dayjs().endOf("day").toDate()}
        excludeDates={unavailable}
        dateFormat={dateFormat}
        adjustDateOnChange
        dayClassName={date =>
          fewLeft.map(d =>
            d === dayjs(date).format("DD/MM/YYYY")
              ? "few-left-slots"
              : undefined
          )
        }
        renderCustomHeader={({
          monthDate,
          increaseMonth,
          decreaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => {
          return (
            <CalendarHeader>
              <IconWrapper
                onClick={() => {
                  decreaseMonth();
                }}
              >
                <FiChevronLeft
                  fontSize={"1.25rem"}
                  strokeWidth={2.5}
                  color={MOSS_GREEN_800}
                />
              </IconWrapper>

              <MonthName>
                <Body2 bold>
                  {monthDate.toLocaleString("en-US", {
                    month: "short",
                    year: "numeric",
                  })}
                </Body2>
              </MonthName>

              <IconWrapper
                onClick={() => {
                  increaseMonth();
                }}
              >
                <FiChevronRight
                  fontSize={"1.25rem"}
                  strokeWidth={2.5}
                  color={MOSS_GREEN_800}
                />
              </IconWrapper>
            </CalendarHeader>
          );
        }}
        isClearable={false}
        className="flex-row date-picker"
        calendarClassName="availability-calendar"
        popperClassName="calendar-popper"
        selected={selectedDate}
        onChange={handleChange}
        highlightDates={[new Date()]}
        placeholderText={
          placeholderText ? placeholderText : "Please select a date"
        }
        formatWeekDay={nameOfDay => nameOfDay.substr(0, 1)}
      />
    </Wrapper>
  );
};

export default Datepicker;
